var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 128,
    fill: "#E7EEF5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 80,
    width: 81,
    height: 104,
    rx: 10,
    fill: "#F6F8FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 110,
    width: 57,
    height: 3,
    rx: 1.5,
    fill: "#C7CDD3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 128,
    width: 57,
    height: 3,
    rx: 1.5,
    fill: "#C7CDD3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 146,
    width: 57,
    height: 3,
    rx: 1.5,
    fill: "#C7CDD3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 164,
    width: 57,
    height: 3,
    rx: 1.5,
    fill: "#C7CDD3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 73,
    width: 5,
    height: 16,
    rx: 2,
    fill: "#7D858E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 73,
    width: 5,
    height: 16,
    rx: 2,
    fill: "#7D858E"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 73,
    width: 5,
    height: 16,
    rx: 2,
    fill: "#7D858E"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 73,
    width: 5,
    height: 16,
    rx: 2,
    fill: "#7D858E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogHistory);
export default __webpack_public_path__ + "static/media/log-history.a80b1f4f834d20d8f7cd2ea10083c700.svg";
export { ForwardRef as ReactComponent };